// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"layout-module--siteFooter--3hKwG"};